import React, { FC } from 'react'
import AppMain from 'com/AppMain'

interface IndexRouterProps {}

export const IndexRouter: FC<IndexRouterProps> = () => {
  // need a div otherwise will have rendering issues with react snap, unsure why
  return (
    <div>
      <AppMain />
    </div>
  )
}
